<template>
    <div id="paypal-button-container"></div>
</template>

<script>
  import Bus from './Bus'

  export default {
    name: "paypal",
    data() {
      return {
        idCartEncrypted: localStorage.getItem('idCarrello')
      }
    },
    props: {
      email: {
        type: String
      },
      nation: {
        type: String
      },
      pay: {
        type: Boolean
      }
    },
    mounted: function () {
      let _this = this // to use vue istance inside paypal functions

        paypal.Button.render({

          env: process.env.NODE_ENV === 'production' ? 'production' : 'sandbox', // sandbox | production

          style: {
            label: 'checkout',
            size: 'responsive',    // small | medium | large | responsive
            shape: 'rect',     // pill | rect
            color: 'gold',     // gold | blue | silver | black
            tagline: false
          },

          // Show the buyer a 'Pay Now' button in the checkout flow
          commit: true,

          validate: function (actions) {
            _this.toggleButton(actions);
          },

          onClick: function() {
            _this.emitEvent()
          },

          // payment() is called when the button is clicked
          payment: function () {

            // Set up a url on your server to create the payment
            var CREATE_URL = process.env.HOST + '/ws-paypal/paypalQuvestra/createPayment';

            var data = {
              idCartEncrypted: _this.idCartEncrypted,
              email: _this.email,
              nation: _this.nation
            };

            // Make a call to your server to set up the payment
            return paypal.request.post(CREATE_URL, data)
              .then(function (res) {
                return res.paymentID;
              });
          },

          // onAuthorize() is called when the buyer approves the payment
          onAuthorize: function (data, actions) {

            // Set up a url on your server to execute the payment
            var EXECUTE_URL = process.env.HOST + '/ws-paypal/paypalQuvestra/execute';

            // Set up the data you need to pass to your server
            var data = {
              paymentID: data.paymentID,
              payerID: data.payerID,
              idCartEncrypted: _this.idCartEncrypted
            };

            // Make a call to your server to execute the payment
            return paypal.request.post(EXECUTE_URL, data)
              .then(function (res) {
                if (res.rc === 0) {
                  _this.$emit('successPay')
                }
              });
          }

        }, '#paypal-button-container');
    },
    methods: {
      toggleButton: function (actions) {
        // console.log('Ho attivato il bottone: ' + this.pay)
        return this.pay ? actions.enable() : actions.disable();
      },
      emitEvent: function () {
        this.$emit('enablePay','form')
      }
    }
  }
</script>

<style lang="less">

  .paypal-button {
    .paypal-button-text {
      visibility: hidden;
      color: white;
    }
  }

  /* Media query for mobile viewport */
  @media (max-width: 768px) {
    #paypal-button-container {
      width: 100%;
    }
  }

  /* Media query for desktop viewport */
  @media (min-width: 768px) {
    #paypal-button-container {
      width: 250px;
      display: inline-block;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Paypal.vue